import type { TunnelMode } from '../booking/components/shared/TunnelModeSwitch';
import type { BookingFilterConfig, BookingPrestation } from '../booking/types';
import type { RideInitialTrip } from './types';

/**
 * Onglet (Prestations | Trajet) à ouvrir — règle commune aux hôtes du tunnel (/book/[slug],
 * booking-widget des sites publics, widget embarqué `<propelsia-booking>`) : l'onglet demandé
 * (deep-link, retour de paiement) s'il est proposé ; sinon Prestations quand une prestation est
 * déjà présélectionnée (`?ps=`, `preselect-ids`, présélection du bloc) — Trajet la cacherait au
 * visiteur ; sinon Trajet dès que le pro le propose (décision produit 2026-08-25 : le cœur de
 * métier d'un pro VTC hybride reste la course), sinon Prestations.
 */
export function resolveTunnelMode(
  features: { canBook: boolean; canRide: boolean },
  requested?: TunnelMode,
  filters?: Pick<BookingFilterConfig, 'preselect_ids' | 'preselect_lines'>,
): TunnelMode {
  if (requested === 'ride' && features.canRide) return 'ride';
  if (requested === 'booking' && features.canBook) return 'booking';
  const hasPreselection = (filters?.preselect_ids?.length ?? 0) > 0 || (filters?.preselect_lines?.length ?? 0) > 0;
  if (hasPreselection && features.canBook) return 'booking';
  return features.canRide ? 'ride' : 'booking';
}

/**
 * Trajet par défaut d'une carte « Course » (type RIDE) cliquée dans le tunnel classique
 * (`onSelectRidePrestation`), passé au RideTunnel : formule présélectionnée + adresses
 * préremplies, verrous d'adresse compris.
 */
export function rideInitialTripFromPrestation(prestation: BookingPrestation): RideInitialTrip {
  return {
    prestation_id: prestation.prestation_id,
    pickup_address: prestation.ride_default_pickup_address,
    dropoff_address: prestation.ride_default_dropoff_address,
    pickup_locked: prestation.ride_pickup_address_locked,
    dropoff_locked: prestation.ride_dropoff_address_locked,
  };
}
